import { Buffer as BufferPolyfill } from 'buffer'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Toaster } from 'sonner'
import { App } from './app'
import './styles/globals.css'

// Polyfill Buffer for browser environment (needed by @moatless/figma clipboard parser)
if (typeof globalThis.Buffer === 'undefined') {
  ;(globalThis as Record<string, unknown>).Buffer = BufferPolyfill
}

const rootEl = document.getElementById('root')
if (!rootEl) {
  throw new Error('Root element not found')
}

createRoot(rootEl).render(
  <StrictMode>
    <App />
    <Toaster />
  </StrictMode>,
)
